import React from 'react';
import ProductHomePageSectionDetailsFields from './ProductHomePageSectionDetailsFields';

function ViewProductHomePageSection({ SectionData }) {
  return <ProductHomePageSectionDetailsFields formData={SectionData || {}} readOnly />;
}

export default ViewProductHomePageSection;
